export default "__VITE_ASSET__mzbhwUsN__"